import type { ReactNode } from "react";

import type { ClubView } from "../game/types";
import { textoDaSessao, useT } from "../i18n";
import { BotaoComGaveta } from "./BotaoComGaveta";

/**
 * As decisões na fila da rodada, ao lado do sino.
 *
 * Moravam num painel no alto da página, e o painel empurrava o elenco para
 * baixo sempre que havia uma ordem esperando. Agora é uma ampulheta junto do
 * botão de jogar, com o número de decisões no ícone, e a lista abre por cima,
 * como as notificações: é ali que se olha antes de mandar a rodada rodar.
 */
export function FilaDaRodada({
  view,
  busy,
  onCancel,
}: {
  view: ClubView;
  busy: boolean;
  onCancel: (index: number) => void;
}): ReactNode {
  const t = useT();
  const total = view.pending.length;

  return (
    <BotaoComGaveta
      icone="Fila"
      rotulo={t("hub.filaTitulo", { total })}
      conta={total}
      classeDaConta="fila-conta"
      nomeDoDialogo="Fila da rodada"
    >
      {total === 0 ? (
        <p className="muted" style={{ margin: 0, padding: "16px 14px", fontSize: 12.5 }}>
          {t("hub.filaVazia")}
        </p>
      ) : (
        view.pending.map((decisao) => (
          <div className="sino-item fila-item" key={`${String(decisao.index)}-${decisao.kind}`}>
            <span className="fila-texto">{textoDaSessao(decisao.key, decisao.params)}</span>
            <button type="button" className="ghost fila-cancelar" disabled={busy} onClick={() => onCancel(decisao.index)}>
              {t("comum.cancelar")}
            </button>
          </div>
        ))
      )}
    </BotaoComGaveta>
  );
}
